<template lang="pug">
    v-container(class="pa-0 tw-overflow-hidden" fluid)
        v-row(no-gutters)
            v-col(class="pa-0")
                v-card(outlined elevation="0" class="ma-0 tw-overflow-hidden")
                    v-row(no-gutters)
                        v-col(class="pa-0")
                            GmapMap(:center="center" :options="mapOptions" :zoom="15" map-type-id="roadmap"  :style='"width: 100%;height:" + mapHeight')
                                GmapMarker(
                                    :position="position"
                                )
</template>
<script>
    export default {
        props:{
            mapHeight:{
                type: String,
                default: '200px'
            },
            position: {
                type: Object,
                default: () => {
                    return {
                        lat: 20.9999584,
                        lng: -89.6124095
                    }
                }
            }

        },
        data() {
            return{
                mapOptions:{
                    zoomControl:true,
                    mapTypeControl:false,
                    scaleControl:false,
                    streetViewControl:false,
                    fullscreenControl:false,
                    disableDefaultUI: true
                }
            }
        },

        computed: {
            center() {
                let center = {}
                if (!this.position.lat){
                    center.lat = 40.4169019,
                    center.lng = -3.7056721
                } else {
                    center.lat = this.position.lat
                    center.lng = this.position.lng
                }
                return center
            }
        }
        
        // watch: {
        //     position: () => {
        //         let position = {}
        //         position.lat = this.position.lat
        //         position.lng = this.position.lng
        //         console.log('Position in component: ' + position)
        //         return position
        //     }
        // }
    }
</script>